"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTo = exports.getInstructionToShow = exports.shouldShowDropdown = exports.getParentFieldsResultsVisibility = exports.didReachLastPage = exports.calculateMaxHeight = exports.didHitBottom = exports.onDropdownClickHandler = exports.onMouseMoveHandler = exports.onScrollHandler = void 0;
var _mergeInputFieldEventHandlers = require("../mergeInputField.eventHandlers.helper");
var normalSize = 30;
var smallSize = 20;
var borderWidth = 1;
var getItemHeight = function getItemHeight(isSmall) {
  return isSmall ? smallSize : normalSize;
};
var didHitBottom = function didHitBottom(_ref) {
  var offsetHeight = _ref.offsetHeight,
    scrollTop = _ref.scrollTop,
    scrollHeight = _ref.scrollHeight;
  var threshold = 30;
  return offsetHeight + scrollTop >= scrollHeight - threshold;
};
exports.didHitBottom = didHitBottom;
var onScrollHandler = function onScrollHandler(_ref2) {
  var isPaginated = _ref2.isPaginated,
    pageSize = _ref2.pageSize,
    hitBottom = _ref2.didHitBottom,
    onScrollToBottom = _ref2.onScrollToBottom;
  return function (id) {
    return isPaginated && hitBottom && onScrollToBottom(id, pageSize);
  };
};
exports.onScrollHandler = onScrollHandler;
var onMouseMoveHandler = function onMouseMoveHandler(_ref3) {
  var index = _ref3.index,
    highlightedIndex = _ref3.highlightedIndex,
    onHighlightByIndex = _ref3.onHighlightByIndex;
  return function (id) {
    return index !== highlightedIndex && onHighlightByIndex(id, index);
  };
};
exports.onMouseMoveHandler = onMouseMoveHandler;
var onDropdownClickHandler = function onDropdownClickHandler(_ref4) {
  var isMerging = _ref4.isMerging,
    value = _ref4.value,
    cursorPosition = _ref4.cursorPosition,
    highlightedItem = _ref4.highlightedItem,
    onSelect = _ref4.onSelect,
    onUpdateValue = _ref4.onUpdateValue,
    selectedItem = _ref4.selectedItem,
    onUpdateFilter = _ref4.onUpdateFilter,
    onClearHighlight = _ref4.onClearHighlight,
    onMerging = _ref4.onMerging,
    onResetPaging = _ref4.onResetPaging,
    types = _ref4.types;
  return function (id) {
    return highlightedItem && (0, _mergeInputFieldEventHandlers.onSelectResultHandler)(value, {
      isMerging: isMerging,
      cursorPosition: cursorPosition,
      highlightedItem: highlightedItem,
      onSelect: onSelect,
      onUpdateValue: onUpdateValue,
      selectedItem: selectedItem,
      onUpdateFilter: onUpdateFilter,
      onClearHighlight: onClearHighlight,
      onMerging: onMerging,
      onResetPaging: onResetPaging,
      types: types
    })(id);
  };
};
exports.onDropdownClickHandler = onDropdownClickHandler;
var calculateMaxHeight = function calculateMaxHeight(_ref5) {
  var isSmall = _ref5.isSmall,
    pageSize = _ref5.pageSize;
  var size = getItemHeight(isSmall) + borderWidth;
  return (pageSize - 1) * size;
};
exports.calculateMaxHeight = calculateMaxHeight;
var didReachLastPage = function didReachLastPage(_ref6) {
  var numberOfItemsInDropdown = _ref6.numberOfItemsInDropdown,
    pageSize = _ref6.pageSize,
    results = _ref6.results;
  return numberOfItemsInDropdown - pageSize > results.length;
};
exports.didReachLastPage = didReachLastPage;
var isPromotionFieldSelected = function isPromotionFieldSelected(_ref7) {
  var isPromotionSelected = _ref7.isPromotionSelected,
    selectedItem = _ref7.selectedItem;
  return isPromotionSelected && selectedItem.title && selectedItem.parentTitle;
};
var isLookupFieldSelected = function isLookupFieldSelected(_ref8) {
  var isLookupSelected = _ref8.isLookupSelected,
    selectedItem = _ref8.selectedItem;
  return isLookupSelected && selectedItem.title && selectedItem.parentTitle;
};
var getParentFieldsResultsVisibility = function getParentFieldsResultsVisibility(_ref9) {
  var isParentSelected = _ref9.isParentSelected,
    selectedItem = _ref9.selectedItem;
  return isParentSelected && selectedItem.fields !== null && !selectedItem.areFieldsFetching;
};
exports.getParentFieldsResultsVisibility = getParentFieldsResultsVisibility;
var shouldShowDropdown = function shouldShowDropdown(_ref10) {
  var isDropdownVisible = _ref10.isDropdownVisible,
    isPromotionSelected = _ref10.isPromotionSelected,
    isLookupSelected = _ref10.isLookupSelected,
    selectedItem = _ref10.selectedItem;
  return isDropdownVisible && !isPromotionFieldSelected({
    isPromotionSelected: isPromotionSelected,
    selectedItem: selectedItem
  }) && !isLookupFieldSelected({
    isLookupSelected: isLookupSelected,
    selectedItem: selectedItem
  });
};
exports.shouldShowDropdown = shouldShowDropdown;
var getInstructionToShow = function getInstructionToShow(_ref11) {
  var hasPromotionFieldResults = _ref11.hasPromotionFieldResults,
    hasLookupFieldResults = _ref11.hasLookupFieldResults,
    arePropositionResultsVisible = _ref11.arePropositionResultsVisible,
    areLookupResultsVisible = _ref11.areLookupResultsVisible,
    results = _ref11.results,
    locale = _ref11.locale,
    instruction = _ref11.instruction;
  if (arePropositionResultsVisible) {
    return locale[hasPromotionFieldResults ? 'selectPromotionField' : 'noMatchingPromotionFields'];
  }
  if (areLookupResultsVisible) {
    return locale[hasLookupFieldResults ? 'selectLookupField' : 'noMatchingLookupFields'];
  }
  if (results.length === 0) {
    return locale.parameterPlaceholder || instruction;
  }
  return instruction;
};
exports.getInstructionToShow = getInstructionToShow;
var scrollTo = function scrollTo(_ref12) {
  var highlightRef = _ref12.highlightRef;
  return highlightRef && highlightRef.scrollIntoView({
    behavior: 'smooth'
  });
};
exports.scrollTo = scrollTo;